export default __webpack_public_path__ + "locales/pl/CreateEditRoomDialog.json?hash=1e87b565e793ade447aa400e0d4425f5";